<fieldset class="fieldset">
  <legend class="fieldset-legend" data-test="section-label">Embeds</legend>
  <ul class="settings-list">
    <mode-email-setting
      id="preview-images"
      [selected]="selections.previewImages"
      (selectedChange)="embedsSelected.emit({ previewImages: $event })"
      >Preview image of Report
    </mode-email-setting>
    <mode-email-setting
      id="tables-of-raw-data"
      [disabledByWorkspaceSetting]="disableAttachments"
      [selected]="selections.tablesOfRawData"
      (selectedChange)="embedsSelected.emit({ tablesOfRawData: $event })"
      [isDisabled]="disableAttachments"
      data-test="tables-of-raw-data"
      >Tables of raw Query data
    </mode-email-setting>
    <mode-email-setting
      id="url-links"
      [selected]="selections.urlLinks"
      (selectedChange)="embedsSelected.emit({ urlLinks: $event })"
      >URL links to the Report, all Query data, and source code
    </mode-email-setting>
  </ul>
</fieldset>
